import Customers from "./Customers";
import Membership from "./Membership";
import Promo from "./Promo";
import Discount from "./Discount";
export default { Customers, Membership, Promo, Discount };
